"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tabletStyles = exports.responsiveClassName = exports.phoneStyles = exports.desktopStyles = void 0;
require("./responsive.css");
/**
 * DO NOT MODIFY
 * Generated from scripts/codegen/main.ts
 */

const desktopStyles = {
  gap: {
    0: "cds-0-_qbseuh",
    1: "cds-1-_1ltkcq",
    2: "cds-2-_1tn5kwy",
    3: "cds-3-_1wqqwn1",
    4: "cds-4-_1btfnsw",
    5: "cds-5-_i6exax",
    6: "cds-6-_16rpz4p",
    7: "cds-7-_bujnfp",
    8: "cds-8-_n1xdzt",
    9: "cds-9-_20ddpp",
    10: "cds-10-_7tddtv",
    0.5: "cds-0_5-_y84g8f",
    1.5: "cds-1_5-_rcsga2"
  },
  alignItems: {
    'flex-start': "cds-flex-start-fod0i1h",
    'flex-end': "cds-flex-end-foz8shl",
    center: "cds-center-cddym9p",
    stretch: "cds-stretch-s1z9lb5",
    baseline: "cds-baseline-b1h9qgwl"
  },
  alignContent: {
    'flex-start': "cds-flex-start-f1qvhrz7",
    'flex-end': "cds-flex-end-fi92tho",
    center: "cds-center-c9yk1fd",
    stretch: "cds-stretch-s11kcdkv",
    'space-between': "cds-space-between-sup0dia",
    'space-around': "cds-space-around-s1j6w41n"
  },
  alignSelf: {
    'flex-start': "cds-flex-start-fyjea5j",
    'flex-end': "cds-flex-end-f1xkxjit",
    center: "cds-center-c10gwem",
    stretch: "cds-stretch-s1txqk5c",
    baseline: "cds-baseline-bggb8rv",
    auto: "cds-auto-a1cdw1do"
  },
  justifyContent: {
    'flex-start': "cds-flex-start-f12pg40b",
    'flex-end': "cds-flex-end-f1nftxuo",
    center: "cds-center-c14c9f3x",
    'space-between': "cds-space-between-sly14vi",
    'space-around': "cds-space-around-s1123dro",
    'space-evenly': "cds-space-evenly-s7o46ux"
  },
  flexDirection: {
    row: "cds-row-r1n9hnzp",
    column: "cds-column-c1a7fyeq",
    'row-reverse': "cds-row-reverse-rwubbg3",
    'column-reverse': "cds-column-reverse-cfw86wz"
  },
  flexWrap: {
    wrap: "cds-wrap-w19d6l2d",
    nowrap: "cds-nowrap-n1moli6q",
    'wrap-reverse': "cds-wrap-reverse-w10gzb1s"
  },
  flexShrink: {
    1: "cds-1-_14jj5pc",
    2: "cds-2-_177sb7q",
    3: "cds-3-_mtivg2"
  },
  flexGrow: {
    1: "cds-1-_1qt84vo",
    2: "cds-2-_tk92g8",
    3: "cds-3-_xa3x1f"
  },
  display: {
    block: "cds-block-b16zei7s",
    'inline-block': "cds-inline-block-i1dr8win",
    flex: "cds-flex-fl7juw2",
    'inline-flex': "cds-inline-flex-i38wgg2",
    none: "cds-none-n12tcw3d",
    contents: "cds-contents-cu3ieg9",
    grid: "cds-grid-g1tx2j7r"
  },
  visibility: {
    hidden: "cds-hidden-hgfoysy",
    visible: "cds-visible-vvoh761"
  },
  columns: {
    'columns-1': "cds-columns-1-c9zrylv",
    'columns-2': "cds-columns-2-cx4exqb",
    'columns-3': "cds-columns-3-c11lxxw2",
    'columns-4': "cds-columns-4-c11ayeuu",
    'columns-5': "cds-columns-5-codst5",
    'columns-6': "cds-columns-6-ctc6muw",
    'columns-7': "cds-columns-7-c1serrh",
    'columns-8': "cds-columns-8-c1bdr1mj",
    'columns-9': "cds-columns-9-c1unktwu",
    'columns-10': "cds-columns-10-c1fuu5d4",
    'columns-11': "cds-columns-11-c140xq89",
    'columns-12': "cds-columns-12-c1fnqouk"
  },
  colStart: {
    'colStart-1': "cds-colStart-1-cxol91m",
    'colStart-2': "cds-colStart-2-cncwb4m",
    'colStart-3': "cds-colStart-3-c91t3f1",
    'colStart-4': "cds-colStart-4-c1yv41rq",
    'colStart-5': "cds-colStart-5-c19mmy2t",
    'colStart-6': "cds-colStart-6-c1d4u0ox",
    'colStart-7': "cds-colStart-7-cfzswwr",
    'colStart-8': "cds-colStart-8-c1va8g4k",
    'colStart-9': "cds-colStart-9-c1ct9x09",
    'colStart-10': "cds-colStart-10-c1gbh0b9",
    'colStart-11': "cds-colStart-11-cd8f5t7",
    'colStart-12': "cds-colStart-12-cvi9l1m"
  },
  colEnd: {
    'colEnd-1': "cds-colEnd-1-c176chl1",
    'colEnd-2': "cds-colEnd-2-cgqbqe6",
    'colEnd-3': "cds-colEnd-3-c3fjzyq",
    'colEnd-4': "cds-colEnd-4-c1jwzw8p",
    'colEnd-5': "cds-colEnd-5-c7hg430",
    'colEnd-6': "cds-colEnd-6-c7lkish",
    'colEnd-7': "cds-colEnd-7-c1bpw1ru",
    'colEnd-8': "cds-colEnd-8-cvm0zm2",
    'colEnd-9': "cds-colEnd-9-c5sozul",
    'colEnd-10': "cds-colEnd-10-cyhrdlo",
    'colEnd-11': "cds-colEnd-11-c18lp2ee",
    'colEnd-12': "cds-colEnd-12-c19skoe0",
    'colEnd-13': "cds-colEnd-13-c5w2g0y",
    'colEnd-auto': "cds-colEnd-auto-cs0dqre",
    'colEnd--1': "cds-colEnd--1-c1iieay3"
  }
};
exports.desktopStyles = desktopStyles;
const tabletStyles = {
  gap: {
    0: "cds-0-_s2ex8i",
    1: "cds-1-_1vbsy7t",
    2: "cds-2-_17zmju3",
    3: "cds-3-_f2x6fe",
    4: "cds-4-_1xl3yx9",
    5: "cds-5-_g0nmx1",
    6: "cds-6-_io7fcl",
    7: "cds-7-_1is7s5",
    8: "cds-8-_ggdgmt",
    9: "cds-9-_iq2bv9",
    10: "cds-10-_1iwvdvi",
    0.5: "cds-0_5-_5kx5vk",
    1.5: "cds-1_5-_4tmobe"
  },
  alignItems: {
    'flex-start': "cds-flex-start-fj84d6r",
    'flex-end': "cds-flex-end-f1a3kreb",
    center: "cds-center-c8nz0m8",
    stretch: "cds-stretch-sz06npd",
    baseline: "cds-baseline-b1am1xa6"
  },
  alignContent: {
    'flex-start': "cds-flex-start-fhht20l",
    'flex-end': "cds-flex-end-f7vd55v",
    center: "cds-center-cphp1s5",
    stretch: "cds-stretch-s182fxad",
    'space-between': "cds-space-between-s2nk8l6",
    'space-around': "cds-space-around-s1gpddmu"
  },
  alignSelf: {
    'flex-start': "cds-flex-start-f8fvbtg",
    'flex-end': "cds-flex-end-fyf06bp",
    center: "cds-center-cuo1hrg",
    stretch: "cds-stretch-s958rd5",
    baseline: "cds-baseline-b1gjolbl",
    auto: "cds-auto-a3i6u9d"
  },
  justifyContent: {
    'flex-start': "cds-flex-start-f1h4skw6",
    'flex-end': "cds-flex-end-fdt5b7r",
    center: "cds-center-cptl5c5",
    'space-between': "cds-space-between-s1f2lvu1",
    'space-around': "cds-space-around-sv0d9uy",
    'space-evenly': "cds-space-evenly-s1aeifdl"
  },
  flexDirection: {
    row: "cds-row-r1k2w0bh",
    column: "cds-column-c11n7ifr",
    'row-reverse': "cds-row-reverse-r1a0e4eh",
    'column-reverse': "cds-column-reverse-c10egzer"
  },
  flexWrap: {
    wrap: "cds-wrap-wkg7iw8",
    nowrap: "cds-nowrap-nsur8qp",
    'wrap-reverse': "cds-wrap-reverse-wsa8zin"
  },
  flexShrink: {
    1: "cds-1-_1gfjs00",
    2: "cds-2-_4r7poz",
    3: "cds-3-_7oxbca"
  },
  flexGrow: {
    1: "cds-1-_n2nyek",
    2: "cds-2-_6tnjus",
    3: "cds-3-_55yk1a"
  },
  display: {
    block: "cds-block-b14mf43s",
    'inline-block': "cds-inline-block-i1y9rjoj",
    flex: "cds-flex-f1uxzdi8",
    'inline-flex': "cds-inline-flex-i1f1jc09",
    none: "cds-none-nfp0bx4",
    contents: "cds-contents-c1uyy8jp",
    grid: "cds-grid-g15af5n7"
  },
  visibility: {
    hidden: "cds-hidden-huhnnqq",
    visible: "cds-visible-v1hfr8ma"
  },
  columns: {
    'columns-1': "cds-columns-1-c1ye48j3",
    'columns-2': "cds-columns-2-c9r2b55",
    'columns-3': "cds-columns-3-c1era8j3",
    'columns-4': "cds-columns-4-cny55v",
    'columns-5': "cds-columns-5-chxw99o",
    'columns-6': "cds-columns-6-cguws6t",
    'columns-7': "cds-columns-7-c1ymmg01",
    'columns-8': "cds-columns-8-ciirisa",
    'columns-9': "cds-columns-9-c1ylqgyw",
    'columns-10': "cds-columns-10-cqxl9tw",
    'columns-11': "cds-columns-11-c1vo96g5",
    'columns-12': "cds-columns-12-ce9yzw4"
  },
  colStart: {
    'colStart-1': "cds-colStart-1-c13xewsm",
    'colStart-2': "cds-colStart-2-c1msrrfb",
    'colStart-3': "cds-colStart-3-cgewy5c",
    'colStart-4': "cds-colStart-4-c1cmwa83",
    'colStart-5': "cds-colStart-5-c1pjx568",
    'colStart-6': "cds-colStart-6-cprd7mu",
    'colStart-7': "cds-colStart-7-c1n6wptb",
    'colStart-8': "cds-colStart-8-c5k4z43",
    'colStart-9': "cds-colStart-9-chie8h7",
    'colStart-10': "cds-colStart-10-c181t8vz",
    'colStart-11': "cds-colStart-11-c1yv9jqi",
    'colStart-12': "cds-colStart-12-c1vwmn04"
  },
  colEnd: {
    'colEnd-1': "cds-colEnd-1-coffum7",
    'colEnd-2': "cds-colEnd-2-ca0c7u5",
    'colEnd-3': "cds-colEnd-3-c1wnth33",
    'colEnd-4': "cds-colEnd-4-c1fgyrmt",
    'colEnd-5': "cds-colEnd-5-c1f8ikfq",
    'colEnd-6': "cds-colEnd-6-chxy91j",
    'colEnd-7': "cds-colEnd-7-c1glog3s",
    'colEnd-8': "cds-colEnd-8-c15xmd4g",
    'colEnd-9': "cds-colEnd-9-c1bejly3",
    'colEnd-10': "cds-colEnd-10-c1vj5nkm",
    'colEnd-11': "cds-colEnd-11-cawacmf",
    'colEnd-12': "cds-colEnd-12-cw0qvdd",
    'colEnd-13': "cds-colEnd-13-c1jxeydo",
    'colEnd-auto': "cds-colEnd-auto-c1l0osoi",
    'colEnd--1': "cds-colEnd--1-clvn1kn"
  }
};
exports.tabletStyles = tabletStyles;
const phoneStyles = {
  gap: {
    0: "cds-0-_kkwtbm",
    1: "cds-1-_21l4cw",
    2: "cds-2-_1ht1v6k",
    3: "cds-3-_179is4u",
    4: "cds-4-_wv12gl",
    5: "cds-5-_16fvc73",
    6: "cds-6-_9pfzce",
    7: "cds-7-_7lspt3",
    8: "cds-8-_8j5qc1",
    9: "cds-9-_zlt1io",
    10: "cds-10-_1p2fpta",
    0.5: "cds-0_5-_1ur6e61",
    1.5: "cds-1_5-_yl0bul"
  },
  alignItems: {
    'flex-start': "cds-flex-start-f1r2t00g",
    'flex-end': "cds-flex-end-f1b99bxm",
    center: "cds-center-c3b1h3p",
    stretch: "cds-stretch-s1uqkpeq",
    baseline: "cds-baseline-b1rvjz3l"
  },
  alignContent: {
    'flex-start': "cds-flex-start-f4uh2s8",
    'flex-end': "cds-flex-end-f1p8fuz7",
    center: "cds-center-c1au957f",
    stretch: "cds-stretch-sadsbyi",
    'space-between': "cds-space-between-s16fcllo",
    'space-around': "cds-space-around-s1164995"
  },
  alignSelf: {
    'flex-start': "cds-flex-start-f1b3cv99",
    'flex-end': "cds-flex-end-f13vuvyr",
    center: "cds-center-c1u5ct96",
    stretch: "cds-stretch-sgvme1x",
    baseline: "cds-baseline-b94rkng",
    auto: "cds-auto-a90ax6t"
  },
  justifyContent: {
    'flex-start': "cds-flex-start-felmcb3",
    'flex-end': "cds-flex-end-fj2j90g",
    center: "cds-center-cl0g9v5",
    'space-between': "cds-space-between-s7t8bpg",
    'space-around': "cds-space-around-s1og0i88",
    'space-evenly': "cds-space-evenly-s1yhifow"
  },
  flexDirection: {
    row: "cds-row-r1mhv5hm",
    column: "cds-column-cqnpveu",
    'row-reverse': "cds-row-reverse-rssix7s",
    'column-reverse': "cds-column-reverse-c19gl32n"
  },
  flexWrap: {
    wrap: "cds-wrap-w1i3wopq",
    nowrap: "cds-nowrap-n6szelg",
    'wrap-reverse': "cds-wrap-reverse-wt2ebf6"
  },
  flexShrink: {
    1: "cds-1-_1mzpt73",
    2: "cds-2-_h98im2",
    3: "cds-3-_qiu11"
  },
  flexGrow: {
    1: "cds-1-_j975fe",
    2: "cds-2-_3i7lis",
    3: "cds-3-_yo3ime"
  },
  display: {
    block: "cds-block-bay3guk",
    'inline-block': "cds-inline-block-i1ku7waj",
    flex: "cds-flex-f171flmq",
    'inline-flex': "cds-inline-flex-i19vdq5a",
    none: "cds-none-n5z5yv9",
    contents: "cds-contents-c1t4q2zj",
    grid: "cds-grid-g5uze3d"
  },
  visibility: {
    hidden: "cds-hidden-hoti1rh",
    visible: "cds-visible-vevkr6v"
  },
  columns: {
    'columns-1': "cds-columns-1-c9fzzae",
    'columns-2': "cds-columns-2-c1ecd5fs",
    'columns-3': "cds-columns-3-ca4ffh",
    'columns-4': "cds-columns-4-c1931m5v",
    'columns-5': "cds-columns-5-c1mmjgkk",
    'columns-6': "cds-columns-6-ciebtwa",
    'columns-7': "cds-columns-7-c13nli2n",
    'columns-8': "cds-columns-8-czesk0h",
    'columns-9': "cds-columns-9-c2do93b",
    'columns-10': "cds-columns-10-crm0cnx",
    'columns-11': "cds-columns-11-cq2d18d",
    'columns-12': "cds-columns-12-c7h7l85"
  },
  colStart: {
    'colStart-1': "cds-colStart-1-c15fscvo",
    'colStart-2': "cds-colStart-2-c59fy7h",
    'colStart-3': "cds-colStart-3-c1o0is2z",
    'colStart-4': "cds-colStart-4-ci87t4q",
    'colStart-5': "cds-colStart-5-cz0woh4",
    'colStart-6': "cds-colStart-6-c1k2ia0o",
    'colStart-7': "cds-colStart-7-c1a18j4t",
    'colStart-8': "cds-colStart-8-c4g1es0",
    'colStart-9': "cds-colStart-9-c1nj3nlr",
    'colStart-10': "cds-colStart-10-c9nskej",
    'colStart-11': "cds-colStart-11-c1alrvaz",
    'colStart-12': "cds-colStart-12-cj29i79"
  },
  colEnd: {
    'colEnd-1': "cds-colEnd-1-c105idsf",
    'colEnd-2': "cds-colEnd-2-c939pjy",
    'colEnd-3': "cds-colEnd-3-c1e9eosp",
    'colEnd-4': "cds-colEnd-4-c19klqum",
    'colEnd-5': "cds-colEnd-5-c1c0w7m5",
    'colEnd-6': "cds-colEnd-6-cyzo4gb",
    'colEnd-7': "cds-colEnd-7-c17wq8j7",
    'colEnd-8': "cds-colEnd-8-c1oa4mmm",
    'colEnd-9': "cds-colEnd-9-c1xu4scu",
    'colEnd-10': "cds-colEnd-10-c1jualvg",
    'colEnd-11': "cds-colEnd-11-cufke2x",
    'colEnd-12': "cds-colEnd-12-c569z17",
    'colEnd-13': "cds-colEnd-13-c11u7kq7",
    'colEnd-auto': "cds-colEnd-auto-c1dzlcco",
    'colEnd--1': "cds-colEnd--1-c3r0fpi"
  }
};
exports.phoneStyles = phoneStyles;
const responsiveClassName = 'cds-responsive';
exports.responsiveClassName = responsiveClassName;